export default __webpack_public_path__ + "static/media/3b4bfc2e30e7271bc8b624eb61f27fc1aecd785cc3a75e3698b770b3a539246e.020a98fa.svg";